var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChatImageIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 4H24V0H4C1.8 0 0 1.8 0 4V24H4V4ZM16 18L8 32H32L26 20L21.94 29.42L16 18ZM30 13C30 11.34 28.66 10 27 10C25.34 10 24 11.34 24 13C24 14.66 25.34 16 27 16C28.66 16 30 14.66 30 13ZM36 0H22V4H36V18H40V4C40 1.8 38.2 0 36 0ZM36 36H22V40H36C38.2 40 40 38.2 40 36V16H36V36ZM4 22H0V36C0 38.2 1.8 40 4 40H24V36H4V22Z",
  fill: "#D5D6DD"
})));
export { SvgChatImageIcon as ReactComponent };
export default __webpack_public_path__ + "7d2a52a109b13ee76c77748cb6baa167.svg";